import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/authContext';
import { ROLE_TYPES } from 'api/constants';

const ProtectedAdminRoute = ({ children }) => {
  const { auth, role } = useAuth();

  if (auth && role === ROLE_TYPES.admin) return children;

  return <Navigate to="/" replace />;
};

export default ProtectedAdminRoute;
